var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"btn btn-primary filter-button mt-3\" type=\"button\" data-toggle=\"collapse\" data-target=\"#filter\" aria-expanded=\"false\" aria-controls=\"collapseExample\">\n    "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"window") : depth0)) != null ? lookupProperty(stack1,"filterButton") : stack1)) != null ? lookupProperty(stack1,"btnText") : stack1), depth0))
    + "\n</button>";
},"useData":true});